<div fxFlexFill fxLayout="column" style="min-height: 80vh;" fxLayoutGap="10px">

  <!-- Header Section Starts -->
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="center center" fxLayout="row">
      <span class="heading medium" ngClass.xs="heading-xs medium">{{'add_from_excel' | transloco}}</span>
    </span>
  </span>

  <mat-dialog-content [formGroup]="Uploadform" fxLayout="column" fxLayoutGap="12px" style="padding-bottom: 5%;">

    <span fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start" class="form">
      <span fxFlex fxLayout="row" class="uploadtxt" fxLayoutAlign="start"
        ngStyle.xs="font-size:14px;padding-top:2px;">{{'select_template' | transloco}}</span>
      <span fxLayout="row" fxLayoutGap="20px" style="padding-left:7px;padding-bottom:1%;">

        <div fxFlex="45" fxFlexAlign="end" style="padding-bottom: 0px !important;">
          <mat-form-field fxFlex="100">
            <mat-label [ngClass]="{'browse-file': fileName !== fileName | transloco}">{{fileName}}</mat-label>
            <input matInput class="input-field regular" style="cursor: pointer" readonly>
            <input hidden formControlName="fileobj" type="file" id="imageUpload" accept=".xlsx" #fileInput
              (change)="uploadFile($event)" />
            <img alt="img" matSuffix *ngIf="earseIcon" src="assets/icons/erase.png" height="15" width="15"
              (click)="erase()" />
          </mat-form-field>
        </div>
        <div>
          <button color="primary" [disabled]="earseIcon" ngStyle.xs="font-size:12px;"
            mat-stroked-button class="upload-button medium"
            (click)="fileInput.click()">{{'browse_file' | transloco}}</button>
        </div>


      </span>
      <span fxLayout="row" class="uploadtxt" fxLayoutAlign="start"
        ngStyle.xs="font-size:14px;padding-top:0%;">{{'use_mentioned_template_here' | transloco}}&nbsp;
        <a dir="auto" class="download-file" download="Template" target="_blank" href="/assets/Template.xlsx">
          - {{'download_excel_template' | transloco}}
        </a>
      </span>
    </span>
    <div fxFlexAlign="start" fxFlex="100" class="div-nosite" *ngIf="excelUserList.length === 0 && !showexcelerror">0
      {{'people_added'|transloco}}
    </div>

    <div *ngIf="showexcelerror">
      <div style="padding:13%" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center">
        <div fxLayout="row">
          <span class="no-result-found bold">{{'invalid_data_contains_multiple_errors' | transloco}}</span>
        </div>
        <div fxLayout="row">
          <span class="no-result-found bold">{{'please_correct_data_and_import_it_again' | transloco}}</span>
        </div>
      </div>
    </div>

    <!-- Count Section Starts Here -->
    <div fxFlex="100" fxLayout="row" class="site-count" *ngIf="excelUserList.length !== 0 && !showexcelerror">
      <span fxLayoutAlign="start center" id="count">{{totalPeopleAdded}}</span>
    </div>

    <!-- User Profile List Starts -->
    <div *ngIf="!showexcelerror" style="height: 30vh; overflow-y: auto; overflow-x: hidden;">

      <div fxFlex fxLayout="column" class="div-list" *ngIf="excelUserList.length !== 0">
        <mat-divider></mat-divider>
        <mat-list style="padding-top: 0px !important;">
          <mat-list-item *ngFor="let user of excelUserList;let i = index" style="padding-top: 10px;">
            <div fxFlex fxLayout="row" class="list">
              <div fxLayout="column">
                <span>{{user.displayName}}</span>
              </div>
              <div fxFlex fxLayoutAlign="end center">
                <span id="cross" style="width: 9px; height: 19px;cursor: pointer;font-family: SLBSans-Medium;"
                  (click)="delete(i)">X</span>
              </div>
            </div>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
      </div>

    </div>
  </mat-dialog-content>

</div>

<mat-dialog-actions fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="row" style="padding-bottom: 40px;" fxLayoutGap="10px">
    <!-- Button Section starts -->
    <div fxLayout="column" fxLayoutAlign="center center">
      <span fxLayoutGap="20px" class="div-btn" fxLayout="row">
        <div fxFlex="50" fxLayoutAlign="start ">
          <button color="primary" ngStyle.xs="font-size:12px;" mat-stroked-button
            class="cancel-button medium" (click)="onNoClick()">{{'cancel' |transloco}}</button>
        </div>
        <div fxFlex="50" fxLayoutAlign="end ">
          <button color="primary" [disabled]="excelUserList.length === 0" ngStyle.xs="font-size:12px;"
            mat-flat-button class="done-button medium" (click)="onAdd()">{{'add_records' | transloco}}</button>
        </div>
      </span>
    </div>
  </div>
</mat-dialog-actions>
